import leanWordmark from "../assets/lean_logo.png";

// Official Lean by Priyanka wordmark (mint wave + LEAN / BY PRIYANKA).
export function LeanWordmark({ className = "h-10 w-auto", ...props }) {
  return <img src={leanWordmark} alt="Lean by Priyanka" className={className} {...props} />;
}


export function LeanLogo({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="1.5" y="1.5" width="45" height="45" rx="13" fill="#0D0D0D" />
      <path d="M11 19c3.2-3.4 6.5-3.4 9.7 0s6.5 3.4 9.7 0 6.5-3.4 9.7 0" stroke="#8EDDA3" strokeWidth="3" strokeLinecap="round" />
      <path d="M11 26c3.2-3.4 6.5-3.4 9.7 0s6.5 3.4 9.7 0 6.5-3.4 9.7 0" stroke="#8EDDA3" strokeWidth="3" strokeLinecap="round" />
      <path d="M11 33c3.2-3.4 6.5-3.4 9.7 0s6.5 3.4 9.7 0 6.5-3.4 9.7 0" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
